package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FormatListBulletedW500Rounded: ImageVector
    get() {
        if (_formatListBulletedW500Rounded != null) {
            return _formatListBulletedW500Rounded!!
        }
        _formatListBulletedW500Rounded = Builder(name = "FormatListBulletedW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(407.17f, 765.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(395.46f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(407.17f, 765.5f)
                close()
                moveTo(407.17f, 525.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(395.46f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(407.17f, 525.5f)
                close()
                moveTo(407.17f, 285.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(395.46f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(407.17f, 285.5f)
                close()
                moveTo(196.65f, 805.02f)
                quadToRelative(-35.15f, 0.0f, -60.08f, -24.93f)
                quadToRelative(-24.94f, -24.94f, -24.94f, -60.09f)
                quadToRelative(0.0f, -35.15f, 24.94f, -60.09f)
                quadToRelative(24.93f, -24.93f, 60.08f, -24.93f)
                reflectiveQuadToRelative(60.09f, 24.93f)
                quadToRelative(24.93f, 24.94f, 24.93f, 60.09f)
                quadToRelative(0.0f, 35.15f, -24.93f, 60.09f)
                quadToRelative(-24.94f, 24.93f, -60.09f, 24.93f)
                close()
                moveTo(196.65f, 565.02f)
                quadToRelative(-35.15f, 0.0f, -60.08f, -24.93f)
                quadToRelative(-24.94f, -24.94f, -24.94f, -60.09f)
                quadToRelative(0.0f, -35.15f, 24.94f, -60.09f)
                quadToRelative(24.93f, -24.93f, 60.08f, -24.93f)
                reflectiveQuadToRelative(60.09f, 24.93f)
                quadToRelative(24.93f, 24.94f, 24.93f, 60.09f)
                quadToRelative(0.0f, 35.15f, -24.93f, 60.09f)
                quadToRelative(-24.94f, 24.93f, -60.09f, 24.93f)
                close()
                moveTo(136.57f, 300.09f)
                quadToRelative(-24.94f, -24.94f, -24.94f, -60.09f)
                quadToRelative(0.0f, -35.15f, 24.94f, -60.09f)
                quadToRelative(24.93f, -24.93f, 60.08f, -24.93f)
                reflectiveQuadToRelative(60.09f, 24.93f)
                quadToRelative(24.93f, 24.94f, 24.93f, 60.09f)
                quadToRelative(0.0f, 35.15f, -24.93f, 60.09f)
                quadToRelative(-24.94f, 24.93f, -60.09f, 24.93f)
                quadToRelative(-35.15f, 0.0f, -60.08f, -24.93f)
                close()
            }
        }
        .build()
        return _formatListBulletedW500Rounded!!
    }

private var _formatListBulletedW500Rounded: ImageVector? = null
